/**
 * "İKİ ADIMLI DOĞRULAMA SENİN İÇİN ZORUNLU MU" CÜMLESİ — G-AUT-01b
 *
 * ================================================================
 * SUNUCU SAYAÇ ÜRETİYOR, HİÇBİR EKRAN GÖSTERMİYORDU
 * ================================================================
 * `two-factor.ts` → `kurulumZorunluMu` şunu yazıyor:
 *
 *   Zorunlu politika + kurulmamış + geçiş süresi dolmuş -> evet
 *   Geçiş süresi devam ediyor                           -> hayır,
 *                                                          SAYAÇ GÖSTERİLİR
 *
 * Ölçüldü (05.09.2026): `gecisKalanGun` sunucudan geliyor,
 * `apps/ogrenci/src/api.ts` içinde bildiriliyor ve öğrenci
 * uygulamasında **hiçbir yerde** kullanılmıyordu. 2FA kurulu değilken
 * ekranın söylediği tek şey *"Şu an kapalı."* idi.
 *
 * Yani rolüne zorunluluk gelen bir öğrenci, yedi günlük geçiş süresi
 * boyunca hiçbir şey görmüyor; süre dolduğunda da ekran hâlâ *"Şu an
 * kapalı"* diyor. Bu, sunucunun kendi yorumunda söz verdiği sayacın
 * hiç var olmaması demek.
 *
 * ================================================================
 * NEDEN SAF MODÜL
 * ================================================================
 * Dört durum var ve üçü ekranda birbirine çok benziyor. Cümleyi JSX
 * içinde kurmak, bu dört durumun ancak elle tıklanarak sınanabilmesi
 * anlamına gelirdi — ve zorunluluk penceresini elle üretmek için
 * politika değiştirmek gerekiyor.
 */

export interface ZorunlulukGirdisi {
  etkinPolitika: "REQUIRED" | "OPTIONAL" | "DISABLED";
  kuruldu: boolean;
  /** Geçiş süresi DOLMUŞ ve hâlâ kurulmamış (sunucu hesaplıyor). */
  kurulumZorunlu: boolean;
  /** Geçiş süresinde kalan gün; süre yoksa `null`, dolduysa `0`. */
  gecisKalanGun: number | null;
}

/**
 * Ekranda gösterilecek zorunluluk cümlesi; gösterilecek bir şey yoksa
 * `null`.
 *
 * KURULUYSA `null` DÖNÜYOR: o durumu ekran zaten anlatıyor
 * ("zorunlu; kendin kapatamazsın"). İkinci bir cümle, aynı şeyi iki
 * kez söylemek olurdu.
 *
 * SAYI UYDURULMUYOR: `gecisKalanGun` `null` iken gün sayısı içeren
 * cümle kurulmuyor. Sunucu "geçiş hakkı yok" derken ekranın bir süre
 * vaat etmesi, öğrenciyi hiç olmayan bir pencereye güvendirirdi.
 */
export function zorunlulukCumlesi(durum: ZorunlulukGirdisi): string | null {
  if (durum.kuruldu) return null;

  if (durum.kurulumZorunlu) {
    /*
      Burada "giremezsin" YAZMIYOR ve yazmamalı: sunucu bu durumda
      oturumu yine de açıyor (`auth.service.ts` — kullanıcının 2FA'yı
      kurabileceği ekrana erişmesi gerekiyor). Ekranın öğrenciyi
      kurulum ekranına KİLİTLEMESİ ayrı bir karar; verilmedi, o yüzden
      cümle de öyle bir şey vaat etmiyor.
    */
    return "Hesabında iki adımlı doğrulama zorunlu. En kısa sürede kurman gerekiyor.";
  }

  if (
    durum.etkinPolitika === "REQUIRED" &&
    durum.gecisKalanGun !== null &&
    durum.gecisKalanGun > 0
  ) {
    return `Hesabında iki adımlı doğrulama zorunlu olacak. Kurman için ${durum.gecisKalanGun} günün var.`;
  }

  return null;
}
